import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_REST_URL;

export const useSessionTimeout = (onLogout) => {
  const [lastActivity, setLastActivity] = useState(Date.now());
  const [showWarning, setShowWarning] = useState(false);
  const [timeoutConfig, setTimeoutConfig] = useState({
    warningTime: 10 * 60 * 1000,
    timeoutTime: 15 * 60 * 1000,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTimeoutConfig = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/commonEngine/sessionTimeoutTime`
        );
        if (response.data.status && response.data.response.length > 0) {
          const config = response.data.response[0];
          setTimeoutConfig({
            warningTime: parseInt(config.sessionTimeoutWarning) * 60 * 1000,
            timeoutTime: parseInt(config.sessionTimeoutTime) * 60 * 1000,
          });
        }
      } catch (error) {
        console.error("Error fetching session timeout configuration:", error);
      }
    };

    fetchTimeoutConfig();
  }, []);

  const resetTimeout = useCallback(() => {
    setLastActivity(Date.now());
    setShowWarning(false);
  }, []);

  useEffect(() => {
    const events = ["mousedown", "keydown", "scroll", "touchstart"];
    const handleActivity = () => resetTimeout();
    events.forEach((event) => window.addEventListener(event, handleActivity));
    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
    };
  }, [resetTimeout]);

  useEffect(() => {
    const warningInterval = setInterval(() => {
      if (Date.now() - lastActivity > timeoutConfig.warningTime) {
        setShowWarning(true);
      }
    }, 1000);

    const timeoutInterval = setInterval(() => {
      if (Date.now() - lastActivity > timeoutConfig.timeoutTime) {
        onLogout();
        navigate("/signin");
      }
    }, 1000);

    return () => {
      clearInterval(warningInterval);
      clearInterval(timeoutInterval);
    };
  }, [lastActivity, navigate, onLogout, timeoutConfig]);

  return { showWarning, resetTimeout };
};
